import { render, staticRenderFns } from "./vertifyPc.vue?vue&type=template&id=f72b01a2&scoped=true&"
import script from "./vertifyPc.vue?vue&type=script&lang=js&"
export * from "./vertifyPc.vue?vue&type=script&lang=js&"
import style0 from "./vertifyPc.vue?vue&type=style&index=0&id=f72b01a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b01a2",
  null
  
)

export default component.exports